import { useEffect } from "react";
import { loadScript, publicUrlFor, route } from "../../../../globals/constants";
import FastImage from "../../../../globals/elements/fastimg";
import CountUp from "react-countup";
import { NavLink } from "react-router-dom";

export default function Title3({
    options,
    data
}) {

    const desc_list = options?.desc_list?.split('#')

     useEffect(() => {
            loadScript("js/custom.js");
        })

    return (
        <div className="section-full p-t80 p-b50 bg-no-repeat bg-cover" style={{ backgroundImage: `url(${publicUrlFor("images/background/bg15.jpg")})` }}>
                <div className="container">
                    <div className="row">
                        <div className="worker-ex-two">
                            <div className="mt-box">
                                <div className="mt-thum-bx">
                                    <FastImage src={options?.image} alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-12">
                            <div className="sx-shiment-wrap-2">
                                <div className="mt-box m-b30">
                                    <h2 className="display-block m-b15 m-t0">{options?.title}</h2>
                                    <p className="m-b15">{options?.description}</p>
                                    <ul className="list-check-circle primary m-b15">
                                        {
                                            desc_list && desc_list?.length > 0 && desc_list?.map((desc,index) => {
                                                return (
                                                        <li key={`desc-${index}`}>{desc} </li>
                                                )
                                            })
                                        }
                                        
                                    </ul>
                                    <NavLink to={route.pages.ABOUT} className="site-button">Read more</NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {
                            data && data?.length > 0 && data.map((item,index) => {
                                return (
                                    <div key={`item-${index}`} className="col-lg-3 col-md-6 col-sm-6">
                                        <div className="m-b30 text-black mt-icon-box-wraper center bg-white p-a20">
                                            <div className="counter font-50 font-weight-800 m-b15 site-text-primary">
                                                <CountUp end={item?.title} duration={10} />
                                            </div>
                                            <h4 className="m-tb0">{item?.description}</h4>
                                        </div>
                                    </div>
                                )
                            })
                        }
                        
                        
                    </div>
                </div>
            </div>
    )
}